import { RuleTableHandlers, TableConfig } from "../../../../../shared/ui/custom-table/model/table-config.model";

export interface CreditPolicyActionVisibility {
  canConnectBank?: () => boolean;
  canReconcile?: () => boolean;
}

export function createCreditPolicyTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string, defaultFilter?: any } = {},
  visibility: CreditPolicyActionVisibility = {}
): TableConfig {
  const {
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    selectable = false,
    summaryTemplate,
    rowConfig = {},
    headerActions,
    gridActions,
    columns,
  } = handlers;

  const canConnectBank = visibility.canConnectBank || (() => true);
  const canReconcile = visibility.canReconcile || (() => true);

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Editar', icon: 'edit', callback: (row) => handleAction(row, TableRowAction.Edit) },
      { label: 'Constitución', icon: 'account_balance', callback: (row) => handleAction(row, TableRowAction.Constitution) },
      { label: 'Liquidaciones', icon: 'receipt', callback: (row) => handleAction(row, TableRowAction.Liquidation) },
      { label: 'Traspaso', icon: 'swap_horiz', callback: (row) => handleAction(row, TableRowAction.Traspaso) },
      { label: 'Transferencia', icon: 'send', callback: (row) => handleAction(row, TableRowAction.Transferencia) },
      { label: 'Reintegro de efectivo', icon: 'local_atm', callback: (row) => handleAction(row, TableRowAction.WithdrawCash) },
      { label: 'Ingreso de efectivo', icon: 'account_balance_wallet', callback: (row) => handleAction(row, TableRowAction.DepositCash) },
      {
        label: 'Mayor contable',
        icon: 'library_books',
        visible: (row) => !!(row && row.accountingModelsNumber),
        callback: (row) => handleAction(row, TableRowAction.Ledger),
      },
      // Nordigen en negociacion: oculto en el front. Para reactivarlo, descomentar.
      // {
      //   label: (row: any) => row && row.connected ? 'Desconectar banco' : 'Conectar banco',
      //   icon: 'link',
      //   visible: () => canConnectBank(),
      //   callback: (row) => handleAction(row, TableRowAction.ConnectBank),
      // },
      {
        label: 'Conciliación bancaria',
        icon: 'compare_arrows',
        visible: () => canReconcile(),
        callback: (row) => handleAction(row, TableRowAction.Reconcile),
      },
      {
        label: 'Importar extracto',
        icon: 'publish',
        visible: () => canReconcile(),
        callback: (row) => handleAction(row, TableRowAction.ImportTransactions),
      },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) },
    ],
    gridActions: gridActions,
    headerActions: headerActions,
    filterView: options.filterView || '',
    defaultFilter: options.defaultFilter || {},
    rowConfig: {
      ...rowConfig,
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand,
    },
    selectable: selectable,
    pagination: true,
    summaryTemplate: summaryTemplate,
  };
}

export enum TableRowAction {
  Edit = 'edit',
  Delete = 'delete',
  ConnectBank = 'connectBank',
  Reconcile = 'reconcile',
  Constitution = 'constitution',
  Liquidation = 'liquidation',
  Traspaso = 'traspaso',
  Transferencia = 'transferencia',
  WithdrawCash = 'withdrawCash',
  DepositCash = 'depositCash',
  Ledger = 'ledger',
  ImportTransactions = 'importTransactions',
}
